import type { QsoType } from '@/types';

/**
 * Filters lookup data before applying it to a QSO, preserving user-entered
 * fields that shouldn't be overwritten by empty lookup results.
 *
 * - For POTA or FT8 QSOs: location fields are never overwritten from lookup
 * - For other QSOs: user-entered gridsquare is preserved if lookup has none
 */
export function filterLookupDataForQso(
  qso: Partial<QsoType>,
  lookupData: Partial<QsoType>
): Partial<QsoType> {
  const filtered = { ...lookupData };

  // For POTA or FT8, don't override location fields
  if (qso.potaRef || qso.ft8) {
    delete filtered.gridsquare;
    delete filtered.state;
    delete filtered.qth;
    delete filtered.cnty;
  } else if (qso.gridsquare && !lookupData.gridsquare) {
    // Don't overwrite user-entered gridsquare with empty lookup
    delete filtered.gridsquare;
  }

  return filtered;
}
